export const NEWSFEED_SEEN_STORAGE_KEY = 'newsfeed_seen_articles';
